import type { CSSProperties } from "react";
import { Box, Text } from "@mantine/core";

interface Props {
  patientName: string;
  caseNumber: string;
  pageNumber: number;
  totalPages: number;
}

const identityStyle: CSSProperties = {
  fontSize: "11pt",
  fontWeight: 700,
  lineHeight: 1.15,
  minWidth: 0,
  overflowWrap: "anywhere",
  whiteSpace: "normal",
};

export function LegacyHistoricalFooter({
  patientName,
  caseNumber,
  pageNumber,
  totalPages,
}: Props) {
  return (
    <Box
      mt={12}
      px="5.75pt"
      data-report-page-footer="true"
      data-historical-page-footer="true"
    >
      <Text style={identityStyle}>Patient Name: {patientName}</Text>
      <Box
        mt={2}
        style={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 1fr) auto",
          gap: "8pt",
          alignItems: "baseline",
        }}
      >
        <Text style={identityStyle}>Case Number: {caseNumber}</Text>
        <Text size="11pt" fw={700} style={{ whiteSpace: "nowrap" }}>
          Page {pageNumber} of {totalPages}
        </Text>
      </Box>
    </Box>
  );
}
